import React from 'react'
import { func, bool } from 'prop-types'

const HamburgerBtn = ({ onClick, active }) => (
  <div
    className={`hamburger m-o ${active ? 'active' : ''}`}
    id="hamburger-1"
    onClick={() => onClick()}
  >
    <span className="line"/>
    <span className="line"/>
    <span className="line"/>

    <style jsx>{`
      .m-o {
        @media(min-width: 992px) {
          display: none;
        }
      }
      .hamburger {
        padding: 1.75px 2px;
      }
      .hamburger .line{
        cursor: pointer;
        width: 1rem;
        height: .125rem;
        background-color: #a3b4ca;
        display: block;
        margin: .25rem 0 .125rem;
        transition: all 0.3s ease-in-out;
      }
      
      .hamburger:hover{
        cursor: pointer;
      }

      #hamburger-1.active .line:nth-child(1){
        transform: translateY(2px) rotate(-45deg);
      }
      
      #hamburger-1.active .line:nth-child(2){
        transform: translateY(-4px) rotate(45deg);
      }
      
      #hamburger-1.active .line:nth-child(3){
        display: none;
      }
    `}
    </style>
  </div>
)

HamburgerBtn.propTypes = {
  onClick: func,
  active: bool,
}

export default HamburgerBtn
